import React from "react";
import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { ConfigManager } from "../config/ConfigManager.js";
import { PageListBean } from "../ds/client_ds.js";
import {
  FabricVendorMiscellaneousCostDetailReasonBean,
  FabricVendorMiscellaneousCostReasonSearchCriteria,
  RestFabricVendorMiscellaneousCostDetailReasonListRequest,
  RestReadRequest,
} from "../ds/ds.js";
import { DeleteIcon, DropDwnDown, DropDwnUp } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  InputCheckbox,
  InputTextbox,
  ShowError,
} from "../gui_components/UIComponents.js";
import { isEmptyArray } from "../gui_components/Util.js";
import {
  BaseInquiryPageListToolBar,
  BaseInquiryToolBar,
  BaseToolBar,
} from "../modules/BaseModule.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { MasterService } from "../services/MasterService.js";
class FabricVendorMiscellaneousCostDetailListForm extends React.Component {
  constructor(props) {
    super(props);
    this.listFormCodeRef = React.createRef();
  }

  componentDidMount() {}
  componentDidUpdate() {
    this.setInputFocus();
  }
  setInputFocus() {
    if (this.listFormCodeRef.current != null) {
      this.listFormCodeRef.current.focus();
    }
  }
  enterKeyEventHandler = (e) => {
    this.props.enterKeyEventHandler(e);
  };
  onChange = (e) => {
    this.props.onChange(e);
  };
  editService = (e, val, rowData) => {
    if (e.detail === 1) this.props.editService(val, rowData);
  };
  deleteOnClick = (e, val, rowData) => {
    if (e.detail === 1) this.props.deleteOnClick(val, rowData);
  };
  handleSortingChange = (e, accessor) => {
    if (e.detail === 1) this.props.handleSortingChange(accessor);
  };
  clickGoButton = (e) => {
    if (e.detail === 1) this.props.clickGoButton();
  };
  render() {
    let fabricVendorMiscellaneousCostDetailReason_list =
      this.props.fabricVendorMiscellaneousCostDetailReason_list;
    let fabricVendorMiscellaneousCostDetailReasonData =
      this.props.fabricVendorMiscellaneousCostDetailReasonData;
    return (
      <div>
        <div>
          <Row>
            <Col sm="3">
              {this.props.is3PL ? (
                <FormLabel>
                  Item Vendor Miscellaneous Cost Detail Reason
                </FormLabel>
              ) : (
                <FormLabel>
                  Fabric Vendor Miscellaneous Cost Detail Reason
                </FormLabel>
              )}
            </Col>
            <Col sm="2">
              <InputTextbox
                ref={this.listFormCodeRef}
                type="text"
                name="code"
                onChange={this.onChange}
                value={fabricVendorMiscellaneousCostDetailReasonData.code}
                style={{ "text-transform": "uppercase" }}
                enterKeyEventHandler={this.enterKeyEventHandler}
                isMandatory={true}
              ></InputTextbox>
            </Col>

            <Col sm="1">
              <Button
                id="fabric_Add_Button"
                className="text-center"
                onClick={(e) => this.clickGoButton(e)}
              >
                Go
              </Button>
            </Col>
          </Row>
        </div>

        <div className="div_default">
          <Table id="fabrics_tables_default">
            <thead>
              <tr>
                <th onClick={(e) => this.handleSortingChange(e, "code")}>
                  Code{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "code" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "description")}>
                  Name{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "description" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "companyCode")}>
                  CompanyCode{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "companyCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "isActive")}>
                  Active{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "isActive" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th>Remove</th>
              </tr>
            </thead>
            <tbody>
              {fabricVendorMiscellaneousCostDetailReason_list.map(
                (Info, index) => (
                  <tr key={index}>
                    <td>
                      <Button
                        variant="secondry"
                        className="hyperLinkText"
                        onClick={(e) => this.editService(e, Info.code, Info)}
                      >
                        {Info.code}
                      </Button>
                    </td>
                    <td> {Info.description}</td>
                    <td>{Info.companyCode}</td>
                    <td>{Info.isActive}</td>
                    <td className="text-right">
                      <Button
                        variant="secondry"
                        className="hyperLinkText"
                        onClick={(e) => this.deleteOnClick(e, Info.code, Info)}
                      >
                        {<DeleteIcon />}
                      </Button>
                    </td>
                  </tr>
                )
              )}
            </tbody>
          </Table>
          {fabricVendorMiscellaneousCostDetailReason_list.length != 0 ? null : (
            <div className="no_Data">{"NO DATA"}</div>
          )}
        </div>
      </div>
    );
  }
}

class FabricVendorMiscellaneousCostDetailEntryForm extends React.Component {
  constructor(props) {
    super(props);
    this.codeRef = React.createRef();
  }

  componentDidMount() {
    this.setInputFocus();
  }
  setInputFocus() {
    if (this.codeRef.current != null) {
      this.codeRef.current.focus();
    }
  }
  onChange = (e) => {
    this.props.onChange(e);
  };

  render() {
    let fabricVendorMiscellaneousCostDetailReasonData =
      this.props.fabricVendorMiscellaneousCostDetailReasonData;
    let isDisableFields = this.props.isDisableFields;

    return (
      <div>
        <Row>
          <Col sm="1">
            {" "}
            <FormLabel>Company Code</FormLabel>{" "}
          </Col>
          <Col sm="2">
            {" "}
            <InputTextbox
              name="companyCode"
              type="text"
              placeholder="Enter CompanyCode"
              onChange={this.onChange}
              value={fabricVendorMiscellaneousCostDetailReasonData.companyCode}
              disabled={true}
              style={{ "text-transform": "uppercase" }}
            />{" "}
          </Col>
          <Col sm="1">
            {" "}
            <FormLabel>Code</FormLabel>{" "}
          </Col>
          <Col sm="2">
            {" "}
            <InputTextbox
              ref={this.codeRef}
              name="code"
              type="text"
              placeholder="Enter FabricVendorMiscellaneousCostDetailReasonCode"
              onChange={this.onChange}
              value={fabricVendorMiscellaneousCostDetailReasonData.code}
              style={{ "text-transform": "uppercase" }}
              disabled={isDisableFields}
              isMandatory={true}
            />{" "}
          </Col>
          <Col sm="1">
            <FormLabel>Name</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <InputTextbox
              name="description"
              type="text"
              placeholder="Enter Name"
              onChange={this.onChange}
              value={fabricVendorMiscellaneousCostDetailReasonData.description}
              style={{ "text-transform": "capitalize" }}
              isMandatory={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>Active</FormLabel>
          </Col>
          <Col sm="2">
            {" "}
            <InputCheckbox
              type="checkbox"
              name="isActive"
              onChange={this.onChange}
              checked={fabricVendorMiscellaneousCostDetailReasonData.isActive}
            />
          </Col>
        </Row>

        <br />
      </div>
    );
  }
}

class FabricVendorMiscellaneousCostDetailList extends React.Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);
    this.state = {
      fabricVendorMiscellaneousCostDetailReason_list: [],
      response: {},
      pageTitle: "Fabric Vendor Miscellaneous Cost Detail",
      fabricVendorMiscellaneousCostDetailReasonData:
        new FabricVendorMiscellaneousCostDetailReasonBean(),
      pageList: new PageListBean(),
      criteria: new FabricVendorMiscellaneousCostReasonSearchCriteria(),
      companyCode: "",
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: false,
      isShowBackButton: false,
      error_list: [],
      isShowExitButton: true,
      totalCount: 0,
      isFabricVendorMiscellaneousCostDetailReasonListFormOpen: true,
      isFabricVendorMiscellaneousCostDetailReasonEntryFormOpen: false,
      isShowNodes: false,
      selectedNode: "headerView",
      alertMessage: [],
      alertType: "",
      isShowAlert: false,
      isPageListToolBar: true,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isDisableFields: false,
      order: "asc",
      sortField: "",
      is3PL: false,
    };
  }

  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.state.is3PL = true;
      this.setState({
        is3PL: true,
      });
    }
    let fabricVendorMiscellaneousCostDetailReasonData =
      new FabricVendorMiscellaneousCostDetailReasonBean();
    fabricVendorMiscellaneousCostDetailReasonData.companyCode =
      this.companyCode;
    this.setState({
      fabricVendorMiscellaneousCostDetailReasonData:
        fabricVendorMiscellaneousCostDetailReasonData,
    });
    this.loadPage(1);
  }
  cleardata = () => {
    let fabricVendorMiscellaneousCostDetailReasonData =
      new FabricVendorMiscellaneousCostDetailReasonBean();
    fabricVendorMiscellaneousCostDetailReasonData.companyCode =
      this.companyCode;
    this.setState({
      fabricVendorMiscellaneousCostDetailReasonData:
        fabricVendorMiscellaneousCostDetailReasonData,
    });
  };
  onChange = (e) => {
    let fabricVendorMiscellaneousCostDetailReasonData =
      this.state.fabricVendorMiscellaneousCostDetailReasonData;
    fabricVendorMiscellaneousCostDetailReasonData[e.target.name] =
      e.target.value;
    this.setState({
      fabricVendorMiscellaneousCostDetailReasonData:
        fabricVendorMiscellaneousCostDetailReasonData,
    });
  };
  saveFabricVendorMiscellaneousCostDetailReasonResponse = (response) => {
    this.handleresponse(response.data);
    this.loadPage(1);
    this.cleardata();
    this.closeFabricVendorMiscellaneousCostDetailReasonEntryForm();
  };

  saveFabricVendorMiscellaneousCostDetailReason = () => {
    let input = this.state.fabricVendorMiscellaneousCostDetailReasonData;
    if (input.isFetched == true) {
      if (
        SecurityAccessManager.FabricVendorMiscellaneousCostDetailMaintenanceEdit_IsAccessible()
      ) {
        MasterService.updateFabricVendorMiscellaneousCostDetailReason(
          input,
          this.saveFabricVendorMiscellaneousCostDetailReasonResponse,
          this.errorCallBack
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    } else {
      if (
        SecurityAccessManager.FabricVendorMiscellaneousCostDetailMaintenanceCreate_IsAccessible()
      ) {
        MasterService.createFabricVendorMiscellaneousCostDetailReason(
          input,
          this.saveFabricVendorMiscellaneousCostDetailReasonResponse,
          this.errorCallBack
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };

  editFabricVendorMiscellaneousCostDetailReasonResponse = (response) => {
    if (response.data != null) {
      if (response.data.fabricCostReasonBean != null) {
        let fabricCostReasonBean = response.data.fabricCostReasonBean;
        this.setState({
          fabricVendorMiscellaneousCostDetailReasonData: fabricCostReasonBean,
        });
        this.disable();
      }
    }
    this.openFabricVendorMiscellaneousCostDetailReasonEntryForm();
  };

  deleteOnClick = (code, rowData) => {
    //
  };

  editService = (code) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = code;
    if (
      SecurityAccessManager.FabricVendorMiscellaneousCostDetailMaintenanceView_IsAccessible()
    ) {
      MasterService.readFabricVendorMiscellaneousCostDetailReason(
        readrestInput,
        this.editFabricVendorMiscellaneousCostDetailReasonResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  handleresponse = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }

    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };

  save = () => {
    this.saveFabricVendorMiscellaneousCostDetailReason();
  };

  back = () => {
    this.clearError();
    this.cleardata();
    this.hideAlertCallBack(false);
    this.closeFabricVendorMiscellaneousCostDetailReasonEntryForm();
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };

  openFabricVendorMiscellaneousCostDetailReasonEntryForm = () => {
    this.setState({
      isFabricVendorMiscellaneousCostDetailReasonListFormOpen: false,
      isFabricVendorMiscellaneousCostDetailReasonEntryFormOpen: true,
      isShowSaveButton: true,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: true,
      isShowBackButton: true,
      isShowNodes: false,
      isPageListToolBar: false,
      isLoadFirstButton: false,
      isLoadLastButton: false,
      isLoadPreviousButton: false,
      isLoadNextButton: false,
    });
    this.hideAlertCallBack();
  };

  closeFabricVendorMiscellaneousCostDetailReasonEntryForm = () => {
    this.clearError();
    let pageTitle = this.moduleCaption;
    this.setState({
      isFabricVendorMiscellaneousCostDetailReasonListFormOpen: true,
      isFabricVendorMiscellaneousCostDetailReasonEntryFormOpen: false,
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowBackButton: false,
      isShowClearErrorButton: false,
      pageTitle: pageTitle,
      isShowNodes: false,
      isPageListToolBar: true,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isDisableFields: false,
    });
  };

  moduleExit = () => {
    this.props.onModuleExit();
  };

  loadFabricVendorMiscellaneousCostDetailReasonResponse = (response) => {
    if (
      response.data != null &&
      response.data.fabricVendorMiscellaneousCostDetailReasonPageListBean !=
        null
    ) {
      let vendorMiscellaneousCostDetailReasonBean = new Array();
      if (
        !isEmptyArray(
          response.data.fabricVendorMiscellaneousCostDetailReasonPageListBean
            .vendorMiscellaneousCostDetailReasonBean
        )
      ) {
        vendorMiscellaneousCostDetailReasonBean =
          response.data.fabricVendorMiscellaneousCostDetailReasonPageListBean
            .vendorMiscellaneousCostDetailReasonBean;
        vendorMiscellaneousCostDetailReasonBean.map((Info) => {
          if (Info.isActive == true) {
            Info.isActive = "True";
          } else {
            Info.isActive = "False";
          }
        });
      }
      let pageList = this.state.pageList;
      pageList.totalCount =
        response.data.fabricVendorMiscellaneousCostDetailReasonPageListBean.totalCount;
      pageList.pageSize =
        response.data.fabricVendorMiscellaneousCostDetailReasonPageListBean.pageSize;
      pageList.currentPage =
        response.data.fabricVendorMiscellaneousCostDetailReasonPageListBean.currentPage;
      this.setState({
        fabricVendorMiscellaneousCostDetailReason_list:
          vendorMiscellaneousCostDetailReasonBean,
        pageList: pageList,
      });
    }
  };
  loadFirst = () => {
    this.loadPage(1);
  };
  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };
  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };

  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    this.loadPage(totalPages);
  };

  loadPage = (pageNumber) => {
    let criteria = new FabricVendorMiscellaneousCostReasonSearchCriteria();
    criteria.companyCode = this.companyCode;
    let pageList = this.state.pageList;
    let pageInput = new PageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPage = pageNumber;
    if (pageList != null) pageInput.totalCount = pageList.totalCount;
    this.state.pageList = pageInput;
    this.loadFabricVendorMiscellaneousCostDetailReasonPage(pageInput, criteria);
  };

  loadFabricVendorMiscellaneousCostDetailReasonPage = (
    pageList,
    searchCriteria
  ) => {
    let requestInput =
      new RestFabricVendorMiscellaneousCostDetailReasonListRequest();
    requestInput.pageInput = pageList;
    requestInput.searchCriteria = searchCriteria;
    this.state.pageList = pageList;
    if (
      SecurityAccessManager.FabricVendorMiscellaneousCostDetailMaintenanceView_IsAccessible()
    ) {
      MasterService.getFabricVendorMiscellaneousCostDetailReasonPageList(
        requestInput,
        this.loadFabricVendorMiscellaneousCostDetailReasonResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };

  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  errorCallBack = (error) => {
    ShowError("Error : " + error);
  };
  enterKeyEventHandler = (e) => {
    e.preventDefault();
    setTimeout(() => {
      this.clickGoButton();
    }, 200);
  };
  clickGoButton = () => {
    let fabricVendorMiscellaneousCostDetailReasonData =
      this.state.fabricVendorMiscellaneousCostDetailReasonData;
    this.editService(fabricVendorMiscellaneousCostDetailReasonData.code);
  };
  handleSortingChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSorting(sortField, sortOrder);
  };
  handleSorting = (sortField, sortOrder) => {
    let list = this.state.fabricVendorMiscellaneousCostDetailReason_list;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ fabricVendorMiscellaneousCostDetailReason_list: sorted });
    }
  };
  render() {
    let pageList = this.state.pageList;
    let totalPages = 0;
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    let currentPage = pageList.currentPage;
    return (
      <div>
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        {this.state.isPageListToolBar && (
          <BaseInquiryPageListToolBar
            currentPage={currentPage}
            totalPages={totalPages}
            isLoadFirstButton={this.state.isLoadFirstButton}
            isLoadLastButton={this.state.isLoadLastButton}
            isLoadPreviousButton={this.state.isLoadPreviousButton}
            isLoadNextButton={this.state.isLoadNextButton}
            loadFirst={this.loadFirst}
            loadLast={this.loadLast}
            loadNext={this.loadNext}
            loadPrevious={this.loadPrevious}
          />
        )}
        {this.state.isFabricVendorMiscellaneousCostDetailReasonListFormOpen && (
          <BaseInquiryToolBar
            onModuleExit={() => this.moduleExit()}
            pageTitle={
              this.state.is3PL
                ? "Item Vendor Miscellaneous Cost Detail"
                : "Fabric Vendor Miscellaneous Cost Detail"
            }
            isShowExitButton={this.state.isShowExitButton}
          />
        )}

        {!this.state
          .isFabricVendorMiscellaneousCostDetailReasonListFormOpen && (
          <BaseToolBar
            back={this.back}
            save={this.save}
            clearError={this.clearError}
            isShowSaveButton={this.state.isShowSaveButton}
            isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
            isShowClearErrorButton={this.state.isShowClearErrorButton}
            isShowBackButton={this.state.isShowBackButton}
            pageTitle={
              this.state.is3PL
                ? "Item Vendor Miscellaneous Cost Detail"
                : "Fabric Vendor Miscellaneous Cost Detail"
            }
          />
        )}
        {this.state.isFabricVendorMiscellaneousCostDetailReasonListFormOpen && (
          <FabricVendorMiscellaneousCostDetailListForm
            {...this.state}
            onChange={this.onChange}
            editService={this.editService}
            deleteOnClick={this.deleteOnClick}
            enterKeyEventHandler={this.enterKeyEventHandler}
            clickGoButton={this.clickGoButton}
            handleSortingChange={this.handleSortingChange}
          />
        )}

        {this.state
          .isFabricVendorMiscellaneousCostDetailReasonEntryFormOpen && (
          <FabricVendorMiscellaneousCostDetailEntryForm
            {...this.state}
            onChange={this.onChange}
          />
        )}
      </div>
    );
  }
}

function FabricVendorMiscellaneousCostDetailAttributeModule(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div className="app">
        <FabricVendorMiscellaneousCostDetailList {...props} name="" />
        <br />
      </div>
    </div>
  );
}
export default FabricVendorMiscellaneousCostDetailAttributeModule;
